import { CircularProgress } from '@mui/material'
import clsx from 'clsx'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

export const LoadingSpinner = ({ className }: ClassName) => (
  <div className={clsx(classes.root, className)} data-testid="loading-spinner">
    <CircularProgress color="inherit" size="1.5rem" />
  </div>
)
